var _excluded = ["once"];
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
/** Keeps track of raw listeners added to the base elements to avoid duplication */
var ledger = new WeakMap();
function editLedger(wanted, baseElement, callback, setup) {
  var _ledger$get, _elementMap$get;
  if (!wanted && !ledger.has(baseElement)) {
    return false;
  }
  var elementMap = (_ledger$get = ledger.get(baseElement)) !== null && _ledger$get !== void 0 ? _ledger$get : new WeakMap();
  ledger.set(baseElement, elementMap);
  var setups = (_elementMap$get = elementMap.get(callback)) !== null && _elementMap$get !== void 0 ? _elementMap$get : new Set();
  elementMap.set(callback, setups);
  var existed = setups.has(setup);
  if (wanted) {
    setups.add(setup);
  } else {
    setups["delete"](setup);
  }
  return existed && wanted;
}
function safeClosest(event, selector) {
  var target = event.target;
  if (target instanceof Text) {
    target = target.parentElement;
  }
  if (target instanceof Element && event.currentTarget instanceof Element) {
    // `.closest()` may match ancestors of `currentTarget` but we only need its children
    var closest = target.closest(selector);
    if (closest && event.currentTarget.contains(closest)) {
      return closest;
    }
  }
}
// This type isn't exported as a declaration, so it needs to be duplicated above
function delegate(selector, type, callback) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var signal = options.signal,
    _options$base = options.base,
    base = _options$base === void 0 ? document : _options$base;
  if (signal !== null && signal !== void 0 && signal.aborted) {
    return;
  }
  // Don't pass `once` to `addEventListener` because it needs to be handled in `delegate-it`
  var once = options.once,
    nativeListenerOptions = _objectWithoutProperties(options, _excluded);
  // `document` should never be the base, it's just an easy way to define "global event listeners"
  var baseElement = base instanceof Document ? base.documentElement : base;
  // Handle the regular Element usage
  var capture = Boolean(_typeof(options) === 'object' ? options.capture : options);
  var listenerFunction = function listenerFunction(event) {
    var delegateTarget = safeClosest(event, String(selector));
    if (delegateTarget) {
      var delegateEvent = Object.assign(event, {
        delegateTarget: delegateTarget
      });
      callback.call(baseElement, delegateEvent);
      if (once) {
        baseElement.removeEventListener(type, listenerFunction, nativeListenerOptions);
        editLedger(false, baseElement, callback, setup);
      }
    }
  };
  var setup = JSON.stringify({
    selector: selector,
    type: type,
    capture: capture
  });
  var isAlreadyListening = editLedger(true, baseElement, callback, setup);
  if (!isAlreadyListening) {
    baseElement.addEventListener(type, listenerFunction, nativeListenerOptions);
  }
  signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', function () {
    editLedger(false, baseElement, callback, setup);
  });
}
export default delegate;